import { useSelect } from '@wordpress/data';
import {
    Typography,
    Grid,
    Card,
    CardContent
} from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import React, { useState, useEffect, useRef } from 'react';
import topic_lodash from 'lodash';
import store from 'store';
export const SENTRY_DSN = 'https://4f2e9e341cc542ca957d9c18745856c7@o263377.ingest.sentry.io/6038490'
export const KEEN_PROJECT_ID = '620c02857a83b63a0a6eb90d';
export const KEEN_KEY = '276cfb980d217befba9ff137c3c95611b8745699c46c21a3fc90fcc8aa7cfb2f988ef1e61a98e68b05e8794876ac4c4c59aca1a4de853e9d62fb4d7d516a551f3fd9a1e133f06edc01592b6adad57f78f683460c2ea632e492ee72f9b8fc92d2';

export const api = {
  BASE_URL_ENV_LOCALSTORAGE_KEY: 'topicEnvs',
  BASE_URL_KEYS: ['TOPIC_BASE_URL', 'ADTHRIVE_PUBDASH_BASE_URL', 'ADTHRIVE_API_BASE_URL'],
  TOPIC_BASE_URL: {
    dev: 'http://localhost:3000/api/',
    staging: 'https://staging.usetopic.com/api/',
    production: 'https://app.usetopic.com/api/'
  },
  ADTHRIVE_PUBDASH_BASE_URL: {
    dev: 'http://localhost:4200/',
    qa: 'https://qa-publisher.adthrive.com/',
    staging: 'https://stage-publisher.adthrive.com/',
    production: 'https://publisher.adthrive.com/'
  },
  ADTHRIVE_API_BASE_URL: {
    dev: 'https://publisher-api.development.cafemedia.com/',
    staging: 'https://stage-publisher-api.adthrive.com/',
    production: 'https://publisher-api.adthrive.com/'
  },
  GET_ENV: (baseUrlType) => {
    let urls = api[baseUrlType];
    let envs = store.get(api.BASE_URL_ENV_LOCALSTORAGE_KEY);
    if(envs && envs[baseUrlType]){
      return envs[baseUrlType];
    } else{
      return 'production';
    }
  },
  GET_BASE_URL: (baseUrlType) => {
    // envs looks like {"TOPIC_BASE_URL": "dev", "ADTHRIVE_PUBDASH_BASE_URL": "staging", ...}
    let urls = api[baseUrlType];
    let env = api.GET_ENV(baseUrlType);
    if(env && urls[env]){
      return urls[env];
    } else{
      return urls.production;
    }
  },
  LOGIN_ENDPOINT: 'login',
  GET_BRIEFS:'keyword_reports/',
  ASYNC_QUESTIONS_STATUS: 'status/questions/',
  GENERATE_RELATIONSHIPS :'openai/generate_relationships/',
  GENERATE_RELATIONSHIPS_QUESTIONS:'openai/generate_relationships_questions/',
  ADTHRIVE_PUBDASH_LOGIN_ENDPOINT: 'login',
  ADTHRIVE_GET_BRIEFS: (siteId) => {
    let env = api.GET_ENV('ADTHRIVE_API_BASE_URL');
    return `${(env === 'dev' || env === 'qa') ? 'develop/' : ''}sites/${siteId}/contentBriefs`
  },
  ADTHRIVE_MARK_BRIEF_COMPLETE: (siteId, briefId) => {
    let env = api.GET_ENV('ADTHRIVE_API_BASE_URL');
    return `${(env === 'dev' || env === 'qa') ? 'develop/' : ''}sites/${siteId}/contentBriefs/${briefId}/actions/completed`;
  },
  ADTHRIVE_SITES_ENDPOINT: () => {
    let env = api.GET_ENV('ADTHRIVE_API_BASE_URL');
    return `${(env === 'dev' || env === 'qa') ? 'develop/' : ''}sites`;
  },
  ADTHRIVE_PUBDASH_BRIEFS: (siteId) => {
    return `${api.GET_BASE_URL('ADTHRIVE_PUBDASH_BASE_URL')}sites/${siteId}/content-optimization/briefs`
  }
}

export const LOAD_BRIEF_PAGE_TEXT = {
    LOAD_BRIEF_HEADING: 'Load Brief',
    BRIEF_TEXTFIELD_LABAL_TEXT: 'Enter the URL to the Content Brief',
    BRIEF_TEXTFIELD_PLACEMENT_TEXT:'https://app.usetopic.com/briefs/xxxxxxx/overview',
    LOAD_BRIEF_BUTTON_TEXT:'GO',
    LOG_IN_BUTTON_TEXT:'Sign In (for non-AdThrive users)',
    SNACKBAR_TEXT_INVALID:'Invalid URL, Please make sure brief is public'
}

export const LOGIN_PAGE_TEXTS = {
    SIGN_IN_TEXT: 'Sign In',
    EMAIL_TEXTFIELD_LABAL_TEXT: 'Email',
    EMAIL_TEXTFIELD_PLACEMENT_TEXT:'login@email.com',
    PASSWORD_TEXTFIELD_LABAL_TEXT: 'Password',
    PASSWORD_TEXTFIELD_PLACEMENT_TEXT:'*********',
    LOGIN_BUTTON_TEXT:'Log In',
    LOAD_BRIEF_BUTTON_TEXT:'Load Brief'
}

export const LOGIN_ADTHRIVE_TEXTS = {
    SIGN_IN_TEXT: 'Sign In with AdThrive',
    LOAD_BRIEF_BUTTON_TEXT: 'Load Brief'
}

export const DASHBOARD_TEXTS = {
    SEARCH_BRIEF_TEXT_HEADING: 'Search Briefs',
    BRIEF_SUB_HEADING_TEXT: 'Content Briefs',
    BRIEF_HOVER_TOOLTIP_TEXT:'Select this Brief',
    BRIEF_LINK_TOOLTIP_TEXT:'View This Brief in Browser',
    BRIEF_SEARCH_PLACEHOLDER_TEXT:'Search briefs by keywords'
}

export const HEADER_TEXTS = {
    LOGGED_IN_TEXT: 'Signed in as',
    NOT_LOGGED_IN_TEXT: 'You are not signed in',
    LOGOUT_ICON_LABEL:'Logout',
    BACK_BUTTON_LABEL: 'Back'


}

export const FOOTER_UTILS = {
    TOPIC_LOGO_URL_LINK : 'https://www.usetopic.com',
    TOPIC_LOGO_LINK:'https://uploads-ssl.webflow.com/5d7bfb33d27da2d97219c009/5d927c199aec2843d190ea20_logo-rectangle.png',
    HELP_TXT_LINK: 'https://help.adthrive.com/hc/en-us',
    WORDPRESS_RELEASE_LINK:'https://wordpress.org/plugins/topic/#developers',
}

export const OUTLINE_UTILS = {
    HEADER_TEXT: 'Competitor Outlines',
    DESCRIPTION_TEXT_1:'Easily see how others are covering this topic so that you can quickly create your own outline.',
    DESCRIPTION_TEXT_2:'Why are some outlines missing?',
    OUTLINE_DESCRIPTION_TEXT:'DESCRIPTION',
    OUTLINE_OUTLINE_TEXT:'OUTLINE'
}

export const BRIEFS_UTIL= {
    CURRENT_GRADE_TEXT: 'Current Grade',
    WORD_COUNT_TEXT:'Word Count : ',
    SELECT_TOPIC_TEXT:'Topics',
    SELECT_QUESTIONS_TEXT:'Questions',
    SELECT_OUTLINES_TEXT:'Outlines',
    TOPIC_CLUSTERING_TEXT_ERROR: 'Something went wrong clustering the topics',
    QUESTIONS_CLUSTERING_TEXT_ERROR: 'Something went wrong clustering the questions'
}

export const QUESTIONS_UTIL = {
    NO_QUESTIONS_ERROR_TEXT:'No questions were found for ',
    HEADER: 'Questions To Answer',
    DESCRIPTION : 'Looking at commonly searched questions can help you understand what kind of answers your audience is looking for. Find natural ways to answer these questions in your content.',
    GOOGLE_QUESTIONS_TEXT_HEADER:'Google People Also Ask',
    QUORA_QUESTIONS_TEXT_HEADER:'Quora',
    QUORA_FOLLOW_COUNT_TEXT:'Follow Count : ',
    AUTOCOMPLETE_QUESTIONS_TEXT_HEADER:'Google Suggest',
    QUESTIONS_TEXT:'Question',
    FETCHING_QUESTIONS_MESSAGE:'Fetching questions to answer'

}

export const TOPIC_UTIL = {
    HEADER: 'Topics to Cover',
    SOURCES_TEXT_1:'used By',
    SOURCES_TEXT_2:'Sources'
}

export const FOOTER_TEXTS = {
    HELP_TXT: 'HELP',
    VERSION_NUMBER: 'v1.0.20',
    MANUAL_LOGIC_TEXT: 'Alternate Login Method',
    LOGOUT_TEXT: 'Log out of Topic Plugin',
}

export const GradeObject = {
  'F' : 1,
  'D-' : 2,
  'D' : 3,
  'D+' : 4,
  'C-' : 5,
  'C' : 6,
  'B-' : 7,
  'B' : 8,
  'B+': 9,
  'A-' : 10, 
  'A' : 11,
  'A+' : 12
}

//WP-BLOCKS Maps contents in the guttenberg editor and returns the value.
export function editorContent() {
//   console.log('editorContent')
  if(window.isClassicEditor){
    return tinymce.get("content").getContent({format: 'raw'});
  } else{
    const visualContent = document.getElementsByClassName('block-editor-writing-flow');

    let contentStringArray = [visualContent[0].innerHTML];
    
    const Blocks = useSelect( ( select ) => {
      return select('core/block-editor').getBlocks()
    }, [] );

    return contentStringArray;
  }
}

export function getHeadingCount(topic){
  try{
    let count = 0;
    topic.header_usage.map((heading) => {
        count += heading.sentences.length;
    });
    return count;
  } catch(e){
    return 0;
  }
}

export function checkValidityOfBriefLink(id) {
  return new Promise((resolve,reject) => {
      fetch(api.GET_BASE_URL('TOPIC_BASE_URL')+api.GET_BRIEFS+`${id}`, {
        method: 'GET',
      }).then(function(response) {
          return response.json();
      })
      .then(function(data) {
          if(!data.error){
            resolve(true);
          }else{
            resolve(false);
          }
      }).catch((err) =>{
          resolve(false);
      });
    });
  }

export function triggerTopicClusters(reportId, success, error){
    fetch(api.GET_BASE_URL('TOPIC_BASE_URL')+api.GENERATE_RELATIONSHIPS+`${reportId}`)
    .then(response => response.json())
    .then((response) => {
        if(!topic_lodash.isEmpty(response.success) && topic_lodash.isFunction(success) ){
        success();
        } else if(topic_lodash.isFunction(error)){
        error(response);
        }
    });
}

export function triggerQuestionClusters(reportId, success, error){
    fetch(api.GET_BASE_URL('TOPIC_BASE_URL')+api.GENERATE_RELATIONSHIPS_QUESTIONS+`${reportId}`)
    .then(response => response.json())
    .then((response) => {
        if(!topic_lodash.isEmpty(response.success) && topic_lodash.isFunction(success) ){
        success();
        } else if(topic_lodash.isFunction(error)){
        error(response);
        }
    });
}

  export function generateOutline(text,tag){
    switch(tag){
        case 'H1':
            return (
                <Typography variant="subtitle2" style={{fontWeight:'700',color:'#3e4b5b'}}>{text}</Typography>
            );
        break;
        case 'H2':
            return (
                <Typography variant="subtitle2" style={{fontWeight:'700',color:'#3e4b5b'}}>{text}</Typography>
            );
        break;
        case 'H3':
            return (
                <Typography variant="body2" style={{color:'#3e4b5b',marginLeft:'1rem'}}>{text}</Typography>
            );
        break;
        case 'H4':
            return (
                <Typography variant="body2" style={{color:'#3e4b5b',marginLeft:'1.3rem'}}>{text}</Typography>
            );
        break;
        case 'H5':
            return (
                <Typography variant="body2" style={{color:'#3e4b5b',marginLeft:'1.5rem'}}>{text}</Typography>
            );
        break;
        case 'H6':
            return (
                <Typography variant="body2" style={{color:'#3e4b5b',marginLeft:'1.6rem'}}>{text}</Typography>
            );
        break;
        default:
            return (
                <Typography variant="body2" style={{color:'#3e4b5b',marginLeft:'1.6rem'}}>{text}</Typography>
            );
    }
}

export function getCustomStyle (selector) {
    switch(selector){
        case '#sidebar':
            return (
                <style>{"\
                .edit-post-sidebar{\
                    min-width: 24rem!important;\
                    padding-bottom:unset!important;\
                }\
                .topic-sidebar.components-panel{\
                    height:calc(100vh - 135px)\
                }\
                "}</style>
            );
        break;
        default:
            return
    }
}

export function loadSkeleton (type) {
    switch(type){
        case 'card':
            return (
                <Grid xs="12">
                    <Card style={{marginBottom:'1rem',borderRadius:'0.5rem'}}>
                        <CardContent>
                            <Skeleton/>
                            <Skeleton/>
                            <Skeleton/>
                        </CardContent>
                    </Card>
                    <Card style={{marginBottom:'1rem',borderRadius:'0.5rem'}}>
                        <CardContent>
                            <Skeleton/>
                            <Skeleton/>
                            <Skeleton/>
                        </CardContent>
                    </Card>
                    <Card style={{marginBottom:'1rem',borderRadius:'0.5rem'}}>
                        <CardContent>
                            <Skeleton/>
                            <Skeleton/>
                            <Skeleton/>
                        </CardContent>
                    </Card>
                </Grid>
            )
        break;
        case 'text':
            return(
                <Typography variant="h3">
                    <Skeleton />
                    <Skeleton />
                    <Skeleton />
                    <br/>
                    <Skeleton />
                    <Skeleton />
                    <Skeleton />
                    <br/>
                    <Skeleton />
                    <Skeleton />
                    <Skeleton />
                    <br/>
                    <Skeleton />
                    <Skeleton />
                    <Skeleton />
                    <br/>
                    <Skeleton />
                    <Skeleton />
                    <Skeleton />
                </Typography>
            );
        break;
        default:
            return;
        break;
    }
}

// hook-compatible way of setting intervals
// https://overreacted.io/making-setinterval-declarative-with-react-hooks/
export function useInterval(callback, delay) {
  const savedCallback = useRef();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}

export function getShuffledClusterColors(seed){
    let colors = [
        '#EF4E4E', // Red
        '#F9AF67', // Orange
        '#79CE87', // Green
        '#55D0DB', // Cyan
        '#55AAD4', // Blue
        '#647ACB',  // Indigo
        '#724BB7',  // Purple
        '#AD4BB8', // Magenta
        '#DA4A91' // Pink
    ];
    function shuffle(array, seed) {
        let m = array.length, t, i;

        // While there remain elements to shuffle…
        while (m) {
    
            // Pick a remaining element…
            i = Math.floor(random(seed) * m--);
    
            // And swap it with the current element.
            t = array[m];
            array[m] = array[i];
            array[i] = t;
            ++seed;
        }
  
        return array;
    }
  
    function random(seed) {
        let x = Math.sin(seed++) * 10000; 
        return x - Math.floor(x);
    }
  
    return shuffle(colors, seed);
}

export const getClusteredQuestions = (report) => {
    try{
      if(report && report.report){
        var {related_questions, related_questions_quora, related_questions_autocomplete} = report.report;
  
        // all the arrays together
        var all_questions = related_questions.questions.concat(related_questions_quora.questions).concat(related_questions_autocomplete.questions);
  
        // remove any questions that are the same or very similar
        all_questions = topic_lodash.uniqBy(all_questions, (q) => {
          return q.keyword.toLowerCase();
        })
  
        // group by cluster
        var question_clusters = topic_lodash.groupBy(all_questions, 'cluster');
        delete question_clusters.undefined;
        return question_clusters;
      } else{
        return [];
      }
    } catch(e){
      console.log('Error in getClusteredQuestions', e);
      return [];
    }
  
  }

export const isDebugMode = () => {
    var url = new URL(window.location.href);
    return url.searchParams.get("topic_debug") === 'true';
}

// Gutenberg does not have a post-save callback hook
// so this is a workaround to allow for similar behavior.
// this thread explains more: https://github.com/WordPress/gutenberg/issues/17632
export function setupPostSaveCallbackHook(callback){
    /**
     * Consults values to determine whether the editor is busy saving a post.
     * Includes checks on whether the save button is busy.
     * 
     * @returns {boolean} Whether the editor is on a busy save state.
     */
    function isSavingPost() {

      // State data necessary to establish if a save is occuring.
      const isSaving = wp.data.select('core/editor').isSavingPost() || wp.data.select('core/editor').isAutosavingPost();
      const isSaveable = wp.data.select('core/editor').isEditedPostSaveable();
      const isPostSavingLocked = wp.data.select('core/editor').isPostSavingLocked();
      const hasNonPostEntityChanges = wp.data.select('core/editor').hasNonPostEntityChanges();
      const isAutoSaving = wp.data.select('core/editor').isAutosavingPost();
      const isButtonDisabled = isSaving || !isSaveable || isPostSavingLocked;

      // Reduces state into checking whether the post is saving and that the save button is disabled.
      const isBusy = !isAutoSaving && isSaving;
      const isNotInteractable = isButtonDisabled && ! hasNonPostEntityChanges;
      
      return isBusy && isNotInteractable;
    }

    if(!window.AP){
        window.AP = {};
    }

    // Current saving state. isSavingPost is defined above.
    window.AP.wasSaving = isSavingPost();

    wp.data.subscribe( () => {

      // New saving state
      let isSaving = isSavingPost();

      // It is done saving if it was saving and it no longer is.
      let isDoneSaving = window.AP.wasSaving && !isSaving;

      // Update value for next use.
      window.AP.wasSaving = isSaving;


      if ( isDoneSaving ) {
        callback();
      } // End of isDoneSaving

    }); // End of wp.data.subscribe
}

export function isValidPermalink(urlString){
    const url = new URL(urlString);
    
    // before a post has been published, its permalink will look like 
    // bad: https://blog.com/blog?p=57
    // instead of good: https://blog.com/blog/post

    // it is only a valid permalink after the post has been published
    if(url.search.includes('?p=')){
        return false;
    } else{
        return true;
    }
}